"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _modelHooksUtils = require("./modelHooksUtils");
var _redaxios = _interopRequireDefault(require("redaxios"));
var _BasicObj = require("./BasicObj");
var _SubObj = _interopRequireDefault(require("./SubObj"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); } /*
 * MIT License
 *
 * Copyright (c) 2022 Massimo Candela <https://massimocandela.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var _type = /*#__PURE__*/new WeakMap();
var _store = /*#__PURE__*/new WeakMap();
var _includes = /*#__PURE__*/new WeakMap();
var _retrieveHook = /*#__PURE__*/new WeakMap();
var _updateHook = /*#__PURE__*/new WeakMap();
var _insertHook = /*#__PURE__*/new WeakMap();
var _deleteHook = /*#__PURE__*/new WeakMap();
var _singleItemQuery = /*#__PURE__*/new WeakMap();
var _batchSize = /*#__PURE__*/new WeakMap();
var _axios = /*#__PURE__*/new WeakMap();
var _loadFunction = /*#__PURE__*/new WeakMap();
var _hiddenFields = /*#__PURE__*/new WeakMap();
var _Model_brand = /*#__PURE__*/new WeakSet();
var _addRelationByField = /*#__PURE__*/new WeakMap();
var _addRelationByFilter = /*#__PURE__*/new WeakMap();
var _removeHiddenFields = /*#__PURE__*/new WeakMap();
var _toArray = /*#__PURE__*/new WeakMap();
var _unWrap = /*#__PURE__*/new WeakMap();
var _insertObjects = /*#__PURE__*/new WeakMap();
var _assignId = /*#__PURE__*/new WeakMap();
var _updateObjects = /*#__PURE__*/new WeakMap();
var _deleteObjects = /*#__PURE__*/new WeakMap();
var _hanldeApiError = /*#__PURE__*/new WeakMap();
var _cleanApiError = /*#__PURE__*/new WeakMap();
var _removeFromStoreSilentlyAfterFailure = /*#__PURE__*/new WeakMap();
var Model = exports["default"] = /*#__PURE__*/_createClass(function Model(name) {
  var _this = this,
    _ref3,
    _options$deep,
    _ref4,
    _options$parseMoment,
    _options$lazyLoad,
    _ref5,
    _options$validate,
    _ref6,
    _options$autoSave,
    _ref7,
    _options$autoRefresh,
    _ref8,
    _options$pre,
    _ref9,
    _options$hiddenFields,
    _ref0,
    _options$post;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  _classCallCheck(this, Model);
  _classPrivateMethodInitSpec(this, _Model_brand);
  _classPrivateFieldInitSpec(this, _type, void 0);
  _classPrivateFieldInitSpec(this, _store, void 0);
  _classPrivateFieldInitSpec(this, _includes, void 0);
  _classPrivateFieldInitSpec(this, _retrieveHook, void 0);
  _classPrivateFieldInitSpec(this, _updateHook, void 0);
  _classPrivateFieldInitSpec(this, _insertHook, void 0);
  _classPrivateFieldInitSpec(this, _deleteHook, void 0);
  _classPrivateFieldInitSpec(this, _singleItemQuery, void 0);
  _classPrivateFieldInitSpec(this, _batchSize, void 0);
  _classPrivateFieldInitSpec(this, _axios, void 0);
  _classPrivateFieldInitSpec(this, _loadFunction, void 0);
  _classPrivateFieldInitSpec(this, _hiddenFields, void 0);
  _defineProperty(this, "ready", void 0);
  _defineProperty(this, "validateObjectAttribute", function (object, key) {
    var validate = _this.options.validate;
    if (validate && validate[key]) {
      try {
        var call = validate[key](object, _classPrivateFieldGet(_store, _this));
        if (call !== null && call !== void 0 && call.then) {
          call.then(function () {
            return object.setError(false, key);
          })["catch"](function (error) {
            return object.setError(error.message, key);
          });
        } else {
          object.setError(false, key);
        }
      } catch (error) {
        object.setError(error.message, key);
      }
    }
  });
  _defineProperty(this, "isObjectValid", function (object) {
    for (var key in object) {
      if (typeof object[key] !== "function") {
        if (object.getError(key)) {
          console.log("Model error", key, object.getError(key));
          return false;
        }
      }
    }
    return true;
  });
  _defineProperty(this, "getStore", function () {
    return _classPrivateFieldGet(_store, _this);
  });
  _defineProperty(this, "setStore", function (store) {
    if (!_classPrivateFieldGet(_store, _this)) {
      var _classPrivateFieldGet2;
      _classPrivateFieldSet(_store, _this, store);
      _classPrivateFieldSet(_axios, _this, _this.options.axios || ((_classPrivateFieldGet2 = _classPrivateFieldGet(_store, _this)) === null || _classPrivateFieldGet2 === void 0 || (_classPrivateFieldGet2 = _classPrivateFieldGet2.options) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.axios) || _redaxios["default"]);
    } else {
      throw new Error("This model was already assigned to a store.");
    }
  });
  _defineProperty(this, "load", function (obj, callback) {
    if (_classPrivateFieldGet(_loadFunction, _this)) {
      return _this.getStore().whenSaved(_this.getType())["catch"](function (e) {
        throw new Error("You cannot perform load() on an unsaved object.");
      }).then(function () {
        var res = _classPrivateFieldGet(_loadFunction, _this).call(_this, obj.toJSON()); // toJSON to avoid side effects;

        if (typeof res === "string") {
          return _classPrivateFieldGet(_axios, _this).call(_this, {
            method: "get",
            url: res,
            responseType: "json"
          }).then(function (data) {
            return data.data;
          }).then(function (data) {
            return callback ? callback(data) : data;
          });
        } else {
          return res;
        }
      }).then(function (data) {
        (0, _BasicObj.setValues)(data, _this, _SubObj["default"], obj, obj);
        return data;
      })["catch"](function (error) {
        return _assertClassBrand(_Model_brand, _this, _error).call(_this, error);
      });
    } else {
      return _assertClassBrand(_Model_brand, _this, _error).call(_this, "You must define a loading function in the model to enable load().");
    }
  });
  _defineProperty(this, "addRelation", function (model, param2, param3) {
    if (model) {
      _this.getStore().validateModel(model);
      if (typeof param2 === "string" && (!param3 || typeof param3 === "string")) {
        // explicit model, from, to
        return _classPrivateFieldGet(_addRelationByField, _this).call(_this, model, param2, param3);
      } else if (!param3 && typeof param2 === "function") {
        // explicit model, filterFunction
        return _classPrivateFieldGet(_addRelationByFilter, _this).call(_this, model, param2);
      } else if (!param2 && !param3) {
        // implicit model, from, to (it uses the type as local key and the id as remote key)
        return _classPrivateFieldGet(_addRelationByField, _this).call(_this, model, model.getType(), "id");
      } else {
        throw new Error("Invalid relation declaration");
      }
    } else {
      throw new Error("A relation needs a model");
    }
  });
  _defineProperty(this, "getRelation", function (parentObject, includedType, filterFunction) {
    var filterRelation = _classPrivateFieldGet(_includes, _this)[includedType];
    if (filterRelation) {
      return (parentObject.getModel().options.load ? parentObject.load()["catch"](function () {}) : Promise.resolve()).then(function () {
        return _this.getStore().find(includedType, function (item) {
          return filterRelation(parentObject, item);
        }).then(function (data) {
          return filterFunction ? data.filter(filterFunction) : data;
        });
      });
    } else {
      return _assertClassBrand(_Model_brand, _this, _error).call(_this, "The relation doesn't exist");
    }
  });
  _defineProperty(this, "getType", function () {
    return _classPrivateFieldGet(_type, _this);
  });
  _defineProperty(this, "retrieveAll", function () {
    return (0, _modelHooksUtils.executeHook)("retrieve", _classPrivateFieldGet(_retrieveHook, _this), null, _classPrivateFieldGet(_axios, _this)).then(function (data) {
      if (!Array.isArray(data)) {
        _classPrivateFieldSet(_singleItemQuery, _this, true);
      }
      _this.ready = true;
      return _classPrivateFieldGet(_toArray, _this).call(_this, data);
    }).then(function (data) {
      var _this$options;
      return (_this$options = _this.options) !== null && _this$options !== void 0 && _this$options.pre ? data.map(function (n) {
        return _this.options.pre(n, data);
      }) : data;
    });
  });
  _defineProperty(this, "insertObjects", function (objects) {
    return objects.length ? _classPrivateFieldGet(_insertObjects, _this).call(_this, objects) : Promise.resolve();
  });
  _defineProperty(this, "updateObjects", function (objects) {
    return objects.length ? _classPrivateFieldGet(_updateObjects, _this).call(_this, objects) : Promise.resolve();
  });
  _defineProperty(this, "deleteObjects", function (objects) {
    return objects.length ? _classPrivateFieldGet(_deleteObjects, _this).call(_this, objects) : Promise.resolve();
  });
  _defineProperty(this, "factory", function (params) {
    if (!_this.options.lazyLoad) {
      return Promise.reject("Factory can be used only on a model declared with lazyLoad: true");
    } else {
      return (0, _modelHooksUtils.executeHook)("retrieve", _classPrivateFieldGet(_retrieveHook, _this), params, _classPrivateFieldGet(_axios, _this)).then(function (data) {
        if (!Array.isArray(data)) {
          _classPrivateFieldSet(_singleItemQuery, _this, true);
        }
        return _classPrivateFieldGet(_toArray, _this).call(_this, data);
      });
    }
  });
  _classPrivateFieldInitSpec(this, _addRelationByField, function (model, localField) {
    var remoteField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "id";
    var filterFunction = function filterFunction(parentObject, child) {
      return parentObject[localField] === child[remoteField];
    };
    return _classPrivateFieldGet(_addRelationByFilter, _this).call(_this, model, filterFunction);
  });
  _classPrivateFieldInitSpec(this, _addRelationByFilter, function (model, filterFunction) {
    var includedType = model.getType();
    _classPrivateFieldGet(_includes, _this)[includedType] = filterFunction;
  });
  _classPrivateFieldInitSpec(this, _removeHiddenFields, function (json) {
    var _ref;
    var _iterator = _createForOfIteratorHelper((_ref = _this === null || _this === void 0 ? void 0 : _classPrivateFieldGet(_hiddenFields, _this)) !== null && _ref !== void 0 ? _ref : []),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var attribute = _step.value;
        delete json[attribute];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (json && _typeof(json) === "object") {
      for (var _i = 0, _Object$values = Object.values(json); _i < _Object$values.length; _i++) {
        var obj = _Object$values[_i];
        if (obj && _typeof(obj) === "object") {
          _classPrivateFieldGet(_removeHiddenFields, _this).call(_this, obj);
        }
      }
    }
    return json;
  });
  _classPrivateFieldInitSpec(this, _toArray, function (data) {
    if (Array.isArray(data)) {
      if (data.length && data.every(function (str) {
        return ["string", "number"].includes(_typeof(str));
      })) {
        return [{
          value: data
        }];
      } else {
        return data;
      }
    } else {
      if (["string", "number"].includes(_typeof(data))) {
        return [{
          value: data
        }];
      } else {
        return [data];
      }
    }
  });
  _classPrivateFieldInitSpec(this, _unWrap, function (objects) {
    var arrayObjects = Object.values(objects);
    var data = arrayObjects.map(function (object) {
      return _classPrivateFieldGet(_removeHiddenFields, _this).call(_this, object.toJSON());
    }).map(function (object) {
      var _this$options2;
      return (_this$options2 = _this.options) !== null && _this$options2 !== void 0 && _this$options2.post ? _this.options.post(object, arrayObjects) : object;
    });
    if (data.value != null && Object.keys(data).length === 1) {
      return data.value;
    } else if (Array.isArray(data) && data.length === 1 && data[0].value != null && Object.keys(data[0]).length === 1) {
      return data[0].value;
    } else {
      return data;
    }
  });
  _classPrivateFieldInitSpec(this, _insertObjects, function (objects) {
    var operation = "insert";
    return (0, _modelHooksUtils.executeHook)(operation, _classPrivateFieldGet(_insertHook, _this), _classPrivateFieldGet(_unWrap, _this).call(_this, objects), _classPrivateFieldGet(_axios, _this)).then(function (data) {
      if (data) {
        _classPrivateFieldGet(_assignId, _this).call(_this, data, objects);
      }
      _classPrivateFieldGet(_cleanApiError, _this).call(_this, objects);
      return data;
    }).then(_classPrivateFieldGet(_toArray, _this))["catch"](function (error) {
      _classPrivateFieldGet(_removeFromStoreSilentlyAfterFailure, _this).call(_this, objects);
      return _classPrivateFieldGet(_hanldeApiError, _this).call(_this, error, objects, operation);
    });
  });
  _classPrivateFieldInitSpec(this, _assignId, function (data, objects) {
    if (Array.isArray(data) && Array.isArray(objects) && objects.length === data.length) {
      for (var i = 0; i < data.length; i++) {
        (0, _BasicObj.setValues)(data[i], _this, _SubObj["default"], objects[i], objects[i]);
        objects[i].setId(data[i].id);
        delete objects[i].setId;
      }
    }
  });
  _classPrivateFieldInitSpec(this, _updateObjects, function (objects) {
    var operation = "update";
    return (0, _modelHooksUtils.executeHook)(operation, _classPrivateFieldGet(_updateHook, _this), _classPrivateFieldGet(_unWrap, _this).call(_this, objects), _classPrivateFieldGet(_axios, _this)).then(function (data) {
      if (Array.isArray(data) && Array.isArray(objects) && objects.length === data.length) {
        for (var i = 0; i < data.length; i++) {
          (0, _BasicObj.setValues)(data[i], _this, _SubObj["default"], objects[i], objects[i]);
        }
      }
      _classPrivateFieldGet(_cleanApiError, _this).call(_this, objects);
      return data;
    }).then(_classPrivateFieldGet(_toArray, _this))["catch"](function (error) {
      return _classPrivateFieldGet(_hanldeApiError, _this).call(_this, error, objects, operation);
    });
  });
  _classPrivateFieldInitSpec(this, _deleteObjects, function (objects) {
    var operation = "delete";
    return (0, _modelHooksUtils.executeHook)(operation, _classPrivateFieldGet(_deleteHook, _this), _classPrivateFieldGet(_unWrap, _this).call(_this, objects), _classPrivateFieldGet(_axios, _this)).then(function (data) {
      _classPrivateFieldGet(_cleanApiError, _this).call(_this, objects);
      return data;
    }).then(_classPrivateFieldGet(_toArray, _this))["catch"](function (error) {
      return _classPrivateFieldGet(_hanldeApiError, _this).call(_this, error, objects, operation);
    });
  });
  _classPrivateFieldInitSpec(this, _hanldeApiError, function (error, objects, operation) {
    var _error$response$data, _error2, _ref2, _error$message, _error3, _error4;
    error = (_error$response$data = (_error2 = error) === null || _error2 === void 0 || (_error2 = _error2.response) === null || _error2 === void 0 ? void 0 : _error2.data) !== null && _error$response$data !== void 0 ? _error$response$data : error;
    var targets = objects.map(function (object) {
      return object.getId();
    });

    // Set errors
    var strError = (_ref2 = (_error$message = (_error3 = error) === null || _error3 === void 0 ? void 0 : _error3.message) !== null && _error$message !== void 0 ? _error$message : (_error4 = error) === null || _error4 === void 0 ? void 0 : _error4.error) !== null && _ref2 !== void 0 ? _ref2 : error;
    Object.values(objects).map(function (object) {
      return object.setError(strError);
    });
    return Promise.reject(_objectSpread(_objectSpread({}, error), {}, {
      targets: targets,
      operation: operation
    }));
  });
  _classPrivateFieldInitSpec(this, _cleanApiError, function (objects) {
    Object.values(objects).map(function (object) {
      return object.setError(false);
    });
  });
  _classPrivateFieldInitSpec(this, _removeFromStoreSilentlyAfterFailure, function (objects) {
    var _iterator2 = _createForOfIteratorHelper(objects.map(function (object) {
        return object.getId();
      })),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var target = _step2.value;
        delete _this.getStore().models[_this.getType()].storedObjects[target];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  });
  _classPrivateFieldSet(_type, this, name);
  this.options = _objectSpread(_objectSpread({}, _typeof(options) === "object" ? options : {}), {}, {
    deep: (_ref3 = (_options$deep = options.deep) !== null && _options$deep !== void 0 ? _options$deep : defaults.deep) !== null && _ref3 !== void 0 ? _ref3 : true,
    parseMoment: (_ref4 = (_options$parseMoment = options.parseMoment) !== null && _options$parseMoment !== void 0 ? _options$parseMoment : defaults.parseMoment) !== null && _ref4 !== void 0 ? _ref4 : false,
    lazyLoad: (_options$lazyLoad = options.lazyLoad) !== null && _options$lazyLoad !== void 0 ? _options$lazyLoad : defaults.lazyLoad,
    validate: (_ref5 = (_options$validate = options.validate) !== null && _options$validate !== void 0 ? _options$validate : defaults.validate) !== null && _ref5 !== void 0 ? _ref5 : {},
    autoSave: (_ref6 = (_options$autoSave = options.autoSave) !== null && _options$autoSave !== void 0 ? _options$autoSave : defaults.autoSave) !== null && _ref6 !== void 0 ? _ref6 : null,
    autoRefresh: (_ref7 = (_options$autoRefresh = options.autoRefresh) !== null && _options$autoRefresh !== void 0 ? _options$autoRefresh : defaults.autoRefresh) !== null && _ref7 !== void 0 ? _ref7 : false,
    pre: (_ref8 = (_options$pre = options.pre) !== null && _options$pre !== void 0 ? _options$pre : defaults.pre) !== null && _ref8 !== void 0 ? _ref8 : null,
    hiddenFields: (_ref9 = (_options$hiddenFields = options.hiddenFields) !== null && _options$hiddenFields !== void 0 ? _options$hiddenFields : defaults.hiddenFields) !== null && _ref9 !== void 0 ? _ref9 : [],
    post: (_ref0 = (_options$post = options.post) !== null && _options$post !== void 0 ? _options$post : defaults.post) !== null && _ref0 !== void 0 ? _ref0 : null
  });
  _classPrivateFieldSet(_store, this, null);
  _classPrivateFieldSet(_includes, this, {});
  _classPrivateFieldSet(_axios, this, this.options.axios || _redaxios["default"]);
  _classPrivateFieldSet(_hiddenFields, this, this.options.hiddenFields);
  _classPrivateFieldSet(_loadFunction, this, this.options.load || null);
  if (!name || !options) {
    throw new Error("A Model requires at least a name and a hook");
  }
  if (_classPrivateFieldGet(_loadFunction, this) && typeof _classPrivateFieldGet(_loadFunction, this) !== "function") {
    throw new Error("The load option must be a function");
  }
  var _ref1 = _typeof(options) === "object" ? (0, _modelHooksUtils.getHooksFromOptions)(options) : (0, _modelHooksUtils.getHooksFromUrl)(options),
    _ref10 = _slicedToArray(_ref1, 4),
    retrieveHook = _ref10[0],
    insertHook = _ref10[1],
    updateHook = _ref10[2],
    deleteHook = _ref10[3];
  _classPrivateFieldSet(_retrieveHook, this, retrieveHook);
  _classPrivateFieldSet(_updateHook, this, updateHook);
  _classPrivateFieldSet(_insertHook, this, insertHook);
  _classPrivateFieldSet(_deleteHook, this, deleteHook);
  _classPrivateFieldSet(_singleItemQuery, this, false); // By default use arrays
  _classPrivateFieldSet(_batchSize, this, 4); // For HTTP requests in parallel if your API doesn't support multiple resources

  if (this.options.autoRefresh && typeof this.options.autoRefresh === "number") {
    setInterval(function () {
      _this.getStore().refresh(_classPrivateFieldGet(_type, _this))["catch"](function () {});
    }, this.options.autoRefresh);
  }
});
function _error(error) {
  error = error.message || error;
  this.getStore().pubSub.publish("error", error);
  return Promise.reject(error);
}